module.exports = __webpack_public_path__ + "img/rigging_seguridad.9b5d7dbd.jpg";